
class TagListController

    ### @ngInject ###
    constructor: ($scope, $document, $element, $timeout, TagService) ->
        @TagService = TagService
        @scope = $scope
        @timeout = $timeout
        @document = $document
        @element = $element
        @isOpen = false
        @tags = @tags or []
        @params = @params or {}

        @urlListController = $element.controller('dybUrlTagLists')
        if @urlListController
            @programId = @urlListController.program?.id if not @programId?
            @urlListController.addTagList(@)
            @scope.$on('$destroy', => @urlListController.addTagList(@))

        @scope.$watchCollection((=> @tags), @updateParams)

    toggleOpen: ->
        if @isOpen then @close() else @open()
        return

    loadTags: (params) ->
        @TagService.lookupTags(params, @root)
            .then (tags) => @tags = tags

    open: ->
        @isOpen = true
        @element.addClass('open')
        @timeout =>
            @document.bind("click", @documentClick)
            @document.bind("keyup", @documentKeyUp)
        return

    close: =>
        @isOpen = false
        @element.removeClass('open')
        @document.unbind("click", @documentClick)
        @document.unbind("keyup", @documentKeyUp)
        return

    documentClick: (event) =>
        inPicker = @element.find('dyb-tag-picker')[0] in event.path
        inList = @element[0].querySelector('ul.tags') in event.path
        if not (inPicker or inList) then @scope.$apply @close
        return

    documentKeyUp: (event) =>
        if event.keyCode == 27
            @scope.$apply @close
            event.preventDefault()

    addTag: (tag) ->
        @tags.push tag

    removeTag: (tag) ->
        index = @tags.indexOf(tag)
        @tags.splice(index, 1) if index >= 0

    updateParams: (tags) =>
        newParams = {}
        for tag in tags
            newParams[tag.slug] = newParams[tag.slug] or []
            newParams[tag.slug].push tag.value
        angular.copy(newParams, @params)
        @urlListController.paramsChanged(@, @params) if @urlListController
        return


### @ngInject ###
tagListDirective = ->
    restrict: 'E'
    templateUrl: 'util/tags/list'
    scope: {}
    controller: TagListController
    controllerAs: 'ctrl'
    bindToController:
        programId: '='
        root: '@'
        skip: '@'
        addLabel: '@addLabel'
        label: '@label'
        params: '='
        tags: '='

module.directive 'dybTagList', tagListDirective
